$(document).ready(function () {
  $('.pages-popup-open').on('click', function(){
    $('.pages-popup').show();
  });
  $('.pages-popup-close').on('click', function(){
    $('.pages-popup').hide();
  });
  $('.zohopublic-popup-open').on('click', function(){
    $('.zohopublic-popup').show();
  });
  $('.zohopublic-popup-close').on('click', function(){
    $('.zohopublic-popup').hide();
  });
  
  //video start
  $(".videoDisplay").click(function (e) {
    e.preventDefault();
    var productID = $(this).attr("id").replace("videoDisplay-", "");
    $("#list-image-" + productID).hide();
    $("#list-video-" + productID).get(0).src = $(this).attr("data-href");
    $("#list-video-" + productID)
      .get(0)
      .play();
    $(".video-measure-" + productID).hide();
    $("#list-video-" + productID).show();
  });
  $(".list-video-clip").on("ended", function (e) {
    var productID = $(this).attr("id").replace("list-video-", "");
    $("#list-video-" + productID).hide();
    $("#list-image-" + productID).show();
    $(".video-measure-" + productID).show();
  });
  $(".list-video-clip").on("play", function (e) {});
  //video end
  //footer
  $(".footer-change").click(function (e) {
    $(this).toggleClass("active");
    $(this).parent().siblings().find(".active").removeClass("active");
    e.stopPropagation();
  });
  //cms page
  var currentPath = window.location.pathname;
  if (currentPath === "/pages/shop-by-color") {
    $(".more").each(function () {
      dataid = $(this).attr("data-color");
      $("." + dataid + " .color-series:gt(2)").hide();
      $(this).click(function () {
        dataid = $(this).attr("data-color");
        $("." + dataid + " .color-series:gt(2)").show();
        $("." + dataid + " .more").hide();
        $("." + dataid + " .less").show();
      });
    });
    $(".less").each(function () {
      $(this).click(function () {
        dataid = $(this).attr("data-color");
        $("." + dataid + " .color-series:gt(2)").hide();
        $("." + dataid + " .less").hide();
        $("." + dataid + " .more").show();
      });
    });
  }
  if (currentPath === "/pages/color-chart") {
    var $colorchart = $(".help-color-name a");
    $colorchart.on("click", function () {
      $(this).addClass("active").siblings("a").removeClass("active");
      if ($(".colorbar").eq($(this).index()).length > 0) {
        var $colorcharttop = $(".colorbar").eq($(this).index()).offset().top;
      }
      $("html,body").animate({
        scrollTop: $colorcharttop,
      });
    });
    function loadImage(n, t, i) {
      var r = new Image();
      r.src = n;
      r.complete
        ? t.call(r, i)
        : $(r).bind("load", function () {
            t.call(r, i);
          });
    }

    $(".colorbar dl dd div").each(function () {
      $(this).click(function () {
        var n = $(this).attr("title"),
          t = $(this).attr("tott"),
          r = '<img src="' + t + '" /><span>' + n + "</span>",
          i = $(this).parent().parent().find("dt");
        i.html(
          '<div style="height:128px;"></div><span>loading ' + n + "</span>"
        );
        loadImage(t, function () {
          i.html(r);
        });
      });
    });
  }

  //contact us
  $("#province1").change(function () {
    $(".sku").hide();
    $("#province1 option").each(function (i) {
      if ($(this).prop("selected")) {
        if (i == 1) {
          $(".city1").show();
          $(".pre_sale1").show();
          $(".in_sale1").hide();
          $(".after_sale1").hide();
        } else if (i == 2) {
          $(".city1").show();
          $(".pre_sale1").hide();
          $(".in_sale1").show();
          $(".after_sale1").hide();
        } else if (i == 3) {
          $(".city1").show();
          $(".pre_sale1").hide();
          $(".in_sale1").hide();
          $(".after_sale1").show();
        } else if (i == 0) {
          $(".city1").hide();
        }
      }
    });
  });
  $("#province1").change();
  $("#sale_type_sub").change(function (e) {
    var v = $(this).val();
    if (v == "Pre Sale - Product" || v == "Pre Sale - Customization") {
      $(".sku").show();
    } else {
      $(".sku").hide();
    }
  });
});
